import moment from 'moment';
import T from '../../common/components/T';
import { dataSender } from '../../common/utils/router';
import { API_SERVER_URL, generateUniqueId, getIsSafari } from '../../common/utils/utils';
import { svgSprite } from '../../hybrid/wrappers';

export function getFormFields(formData, events = {}, roles, isMobile) {
    // опції для дат
    const timeOptionsStart = [];
    for (let i = 0; i < 24; i++) {
        for (let j = 0; j <= 45; j += 15) {
            const hour = String(i).length === 1 ? `0${i}` : `${i}`;
            const minutes = String(j).length === 1 ? `0${j}` : `${j}`;
            const normalizedOption = `${hour}:${minutes}`;
            timeOptionsStart.push({ value: normalizedOption, label: normalizedOption });
        }
    }
    let timeOptionsEnd = [];

    // якщо дата старту змінена, то дата кінця не може бути меншою, аніж дата старту
    if (formData['date_start']) {
        const indexOfOption = timeOptionsStart.findIndex((option) => option.value === formData['date_start'].value);
        timeOptionsEnd = [
            ...timeOptionsStart.slice(+indexOfOption + 1),
            { value: '23:59', label: <T textName='to-the-day-end' defaultStr='До конца дня' /> }
        ];
    } else {
        timeOptionsEnd = [
            ...timeOptionsStart,
            { value: '23:59', label: <T textName='to-the-day-end' defaultStr='До конца дня' /> }
        ];
    }
    // опції для видимості
    const visibilityOptions = Object.keys(events?.meta?.visibility_types || {}).reduce((acc, item) => {
        acc.push({ value: item, label: events?.meta?.visibility_types?.[item] });
        return acc;
    }, []);

    // ролі проекту
    const normalizedRoles =
        roles &&
        roles?.map((role) => ({
            value: role?.id,
            label: role?.title
        }));

    // додаємо поле в залежності від обраного параметру видимості
    let lastField = {};
    switch (formData['event_calendar_visibility_type_id']?.value) {
        case '3': {
            lastField = {
                attribute: 'user_list',
                type: 'select-users',
                value: formData['user_list'],
                fastSearch: true
            };
            break;
        }
        case '6': {
            lastField = {
                attribute: 'role_list',
                type: 'dropdown-multiselect',
                value: formData['role_list'],
                options: normalizedRoles || [],
                title: { body: <T textName='choose-role' defaultStr='Выберите роль' /> }
            };
            break;
        }
    }

    const date = new Date();

    const tz = Intl.DateTimeFormat('en-US', {
        timeZone: 'Asia/Almaty',
        timeZoneName: 'short'
    }).formatToParts(date);

    const gmt = tz.find((p) => p.type === 'timeZoneName').value;

    const kzTime = new Date().toLocaleTimeString('ru-RU', {
        timeZone: 'Asia/Almaty',
        hour: '2-digit',
        minute: '2-digit',
        second: undefined
    });

    const isSafari = getIsSafari();
    return [
        {
            attribute: 'all_day',
            type: 'radio-switcher',
            options: [
                <T textName='create-event-all-day-option-1' defaultStr='Весь день' key={generateUniqueId()} />,
                <T textName='create-event-all-day-option-2' defaultStr='Выбрать время' key={generateUniqueId()} />
            ],
            value: formData['all_day']
        },
        {
            attribute: 'timezone_hint',
            type: 'info-field',
            html: (
                <>
                    <p>
                        <T textName='create-event-timezone-hint' defaultStr='Выбирайте настройку по времени Казахстана/Алматы' />
                        {` (${gmt})`}
                    </p>
                    <p>
                        <T textName='create-event-timezone-hint-2' defaultStr='Текущее время Казахстана/Алматы' />:{` ${kzTime}`}
                    </p>
                </>
            )
        },
        ...(formData['all_day'] === 1
            ? [
                  {
                      attribute: 'start_time',
                      type: 'select',
                      options: timeOptionsStart,
                      title: { body: <T textName='create-event-date-start-title' defaultStr='Время начала' /> },
                      value: formData['start_time']
                  },
                  {
                      attribute: 'end_time',
                      type: 'select',
                      options: timeOptionsEnd,
                      title: { body: <T textName='create-event-date-end-title' defaultStr='Время окончания' /> },
                      value: formData['end_time']
                  }
              ]
            : []),
        {
            attribute: 'description',
            type: 'textarea',
            title: { body: <T textName='create-event-description-title' defaultStr='Описание события' /> },
            value: formData['description'],
            maxLength: 1000
        },
        {
            attribute: 'link',
            type: 'input',
            title: { body: <T textName='create-event-link-title' defaultStr='Ссылка на событие' /> },
            value: formData['link'],
            addon: <div>{svgSprite('link-gt')}</div>
        },
        {
            attribute: 'event_calendar_visibility_type_id',
            type: 'select',
            title: { body: <T textName='create-event-visibility_type_id-title' defaultStr='Кому доступно событие' /> },
            options: visibilityOptions,
            value: formData['event_calendar_visibility_type_id']?.value
                ? formData['event_calendar_visibility_type_id']
                : visibilityOptions[0]
        },
        lastField,
        {
            attribute: 'type_media',
            type: 'radio-switcher',
            options: [
                <T textName='video' defaultStr='Видео' key={Math.random()} />,
                <T textName='image' defaultStr='Изображение' key={Math.random()} />
            ],
            value: formData['type_media'] === 'picture' ? 1 : 0,
            disabled: formData['youtube'] || formData['video'] || formData['picture']
        },
        ...(formData['type_media'] === 'picture'
            ? [
                  {
                      attribute: 'picture',
                      type: 'image-office-custom',
                      value: formData['picture'],
                      hint: <T textName='create-event-image-hint' defaultStr='Формат изображения JPEG, PNG до 100MB' />,
                      accept: 'image/jpeg, image/jpg, image/png',
                      multiple: false,
                      noDrag: formData['picture'],
                      deleteKey: 'delete_medias',
                      maxFileSize: 1024 * 100
                  }
              ]
            : formData['type_media'] === 'video' || formData['type_media'] === 'youtube'
            ? [
                  {
                      attribute: 'youtube',
                      type: 'input',
                      value: formData['youtube'],
                      title: { body: <T textName='create-event-youtube-title' defaultStr='Ссылка на видео' /> },
                      disabled: formData['video'],
                      addon: <div>{svgSprite('link-gt')}</div>
                  },
                  {
                      attribute: 'video',
                      type: 'image-office-custom',
                      hint: (
                          <>
                              <p>
                                  <T textName='create-event-video-hint-v1' defaultStr='Загружайте видео до 100MB' />
                              </p>
                              {isSafari && isMobile ? (
                                  <p>
                                      <T
                                          textName='create-event-video-hint-2'
                                          defaultStr='Лучше загружать видео из галереи, чтобы избежать проблем с качеством записи'
                                      />
                                  </p>
                              ) : null}
                          </>
                      ),
                      accept: 'video/mp4, video/webm, video/quicktime',
                      multiple: false,
                      value: formData['video'],
                      noDrag: !!formData['youtube'],
                      deleteKey: 'delete_medias',
                      onSuccessLoadText: <T textName='video-successfully-loaded' defaultStr='Видео успешно загружено' />,
                      maxFileSize: 1024 * 100
                  }
              ]
            : []),
        ...(formData['youtube']
            ? [
                  {
                      type: 'youtube-player',
                      videoId: formData['youtube']
                  }
              ]
            : [{}])
    ];
}

export function setFormDataMainFunc(attribute, value, setFormData) {
    let key = attribute;
    let val = value;

    if (key === 'delete_medias') {
        if (!val[0]?.links) {
            return;
        } else {
            key = 'delete_medias';
            val = [value?.[0]?.id];
        }
    }
    if (key === 'youtube') {
        setFormData((state) => ({
            ...state,
            ['type_media']: 'youtube'
        }));
    }
    if (key === 'video') {
        setFormData((state) => ({
            ...state,
            ['type_media']: 'video'
        }));
    }
    const delete_keys = [];
    if (key === 'event_calendar_visibility_type_id') {
        // якщо змінюється тип доступу події і це не id 3 (обраним користувачам), видаляємо властивість user_list
        if (+val?.value !== 3) {
            delete_keys.push('user_list');
        }
        // якщо змінюється тип доступу події і це не id 6 (обраним ролям), видаляємо властивість user_list
        if (+val?.value !== 6) {
            delete_keys.push('role_list');
        }
    }
    if (key === 'type_media') {
        val = value === 0 ? 'video' : 'picture';
    }
    setFormData((state) => {
        delete_keys.forEach((key) => {
            if (state[key]) {
                delete state[key];
            }
        });
        return {
            ...state,
            [key]: val
        };
    });
}

export function getFormButtons(closeHandler, data) {
    return [
        {
            type: 'cancel',
            clickFunc: closeHandler
        },
        {
            type: 'ok',
            buttonText: data?.id ? <T textName='save' defaultStr='Сохранить' /> : <T textName='add' defaultStr='Добавить' />
        }
    ];
}

export const getFormFuncs = () => ({
    start_time: {
        onChange: (val) => val?.value || val
    },
    end_time: {
        onChange: (val) => val?.value || val
    },
    event_calendar_visibility_type_id: {
        onChange: (val) => val?.value || val
    },
    user_list: {
        onChange: (val) => val?.map((elem) => elem?.id) || val
    },
    role_list: {
        onChange: (val) => val?.map((elem) => elem?.value || elem?.id) || val
    }
});

export const getFormStyles = (css) => ({
    description: {
        wrapper: css.description,
        formControlContentPlaceholderArea: css.descriptionInput
    },
    all_day: {
        wrapper: css.all_day_wrapper,
        content: css.all_day,
        togglerBackground: css.all_day_toggler
    },
    start_time: {
        wrapper: css.start_time
    },
    end_time: {
        wrapper: css.end_time
    },
    type_media: {
        wrapper: css.type_media_wrapper,
        content: css.type_media,
        togglerBackground: css.all_day_toggler
    },
    link: {
        formControlContentAddon: css.linkAddon
    },
    youtube: {
        addon: css.linkAddon
    },
    timezone_hint: {
        wrapper: css.timezoneHint
    }
});

export const sendFunction = (
    dataToSend,
    setAllowedSend,
    setFieldsErr,
    userToken,
    lang,
    closeHandler,
    funcs,
    onSuccess,
    setRequestLoading
) => {
    let pictureOrVideoExists = false;
    const modernDataToSend =
        dataToSend && Object.keys(dataToSend).length
            ? Object.keys(dataToSend).reduce((accum, key) => {
                  if (dataToSend[key]) {
                      if (funcs[key] && funcs[key].transform) {
                          if (dataToSend[key]) {
                              accum[key] = funcs[key].transform(dataToSend[key]);
                          } else {
                              accum[key] = null;
                          }
                      } else if (funcs[key] && funcs[key].onChange) {
                          accum[key] = funcs[key].onChange(dataToSend[key]);
                      } else if (key === 'picture' || key === 'video') {
                          // існуючі зображення на бек не посилаєм (буде помилка по типу object)
                          if (!dataToSend[key]?.id) {
                              accum[key] = dataToSend[key];
                          } else if (dataToSend[key]) {
                              pictureOrVideoExists = true;
                          }
                      } else {
                          accum[key] = dataToSend[key];
                      }
                  }
                  return accum;
              }, {})
            : dataToSend;
    const id_edit = Boolean(dataToSend?.id);

    const { youtube, video, type_media } = modernDataToSend;

    if (!youtube && type_media === 'youtube') {
        modernDataToSend.type_media = 'nothing';
        delete modernDataToSend.youtube;
    } else if (!video && type_media === 'video' && !pictureOrVideoExists) {
        modernDataToSend.type_media = 'nothing';
        delete modernDataToSend.video;
    }

    dataSender(
        `${API_SERVER_URL}/api/v1/user/event-calendar${id_edit ? `/${dataToSend.id}` : ''}`,
        id_edit ? 'PATCH' : 'POST',
        {
            ...modernDataToSend,
            timezone: 'Asia/Almaty'
        },
        () => {
            closeHandler();
            onSuccess && onSuccess();
        },
        (error) => {
            if (error?.errors) {
                setFieldsErr(error?.errors);
            }
            setAllowedSend(true);
            setRequestLoading(false);
        },
        userToken,
        lang,
        false,
        'hidden',
        'video'
    );
};

export const getDefaultData = (data, events) => {
    const visibilityOptions = Object.keys(events?.meta?.visibility_types || {}).reduce((acc, item) => {
        acc.push({ value: item, label: events?.meta?.visibility_types?.[item] });
        return acc;
    }, []);

    const start_time = data?.event_start_time
        ? { value: data?.event_start_time, label: data?.event_start_time }
        : { value: '00:00', label: '00:00' };
    const end_time = data?.event_end_time
        ? { value: data?.event_end_time, label: data?.end_time }
        : { value: '23:59', label: '23:59' };

    const all_day = (data?.event_start_time === '00:00' && data?.event_end_time === '23:59') || !data?.id ? 0 : 1;
    return {
        all_day,
        start_time,
        end_time,
        event_calendar_visibility_type_id:
            visibilityOptions?.find((option) => +option?.value === +data?.event_calendar_visibility_type_id) || '1',
        duration_event: '1',
        date: moment(data?.date).format('yyyy-MM-DD'),
        description: data?.description,
        link: data?.link,
        user_list: data?.user_list?.map((user) => ({ ...user, username: user?.label })),
        role_list: data?.role_list,
        id: data?.id,
        picture: data?.picture,
        type_media: data?.type_media && data?.type_media !== 'nothing' ? data?.type_media : 'youtube',
        youtube: data?.youtube ? (data?.youtube?.includes('https') ? data?.youtube : `https://youtu.be/${data?.youtube}`) : '',
        video: data?.video
    };
};
